var map = {
	"./Consumer Running Products.jpg": [
		6042,
		42
	],
	"./Medicine.jpg": [
		9909,
		909
	],
	"./Surgical Product.jpg": [
		2670,
		670
	],
	"./Tablets.jpg": [
		9071,
		71
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1426;
module.exports = webpackAsyncContext;